<div class="field-wrapper" [ngClass]="{ 'dragged-mode': isDraggedMode }">
  <div class="field-action-button" (click)="changeFieldState.emit(name)">
    <ui-svg-icon [name]="isFieldEnabled ? iconNameList.Close : iconNameList.Add" [width]="20"></ui-svg-icon>
  </div>

  @switch (filterTypeByName.get(name)) { @case (filterType.ChipsInput) {
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <mat-chip-grid #chipList>
      @for (item of filtersFormControlOrGroup.value; track $index) {
      <mat-chip-row [removable]="true" (removed)="removeFilter(filtersFormControlOrGroup, item)">
        {{ item }}
        <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
      </mat-chip-row>
      }
      <input
        #chipsInput
        [formControl]="chipsInputControl"
        [matChipInputFor]="chipList"
        [matChipInputAddOnBlur]="true"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addElement(filtersFormControlOrGroup, chipsInput, chipsInputControl)"
      />
      @if (filtersFormControlOrGroup?.value?.length < 2) {
      <ui-svg-icon [name]="iconNameList.ListView" class="svg_transform" matSuffix></ui-svg-icon>
      }
    </mat-chip-grid>
  </mat-form-field>
  } @case (filterType.ChipsInputPopup) {
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <mat-chip-grid #chipList (click)="openFilterDialog(name, label, filtersFormControlOrGroup)">
      @for (item of filtersFormControlOrGroup.value; track item?.value) {
      <mat-chip-row
        [removable]="true"
        [matTooltip]="item?.description"
        (removed)="removeFilter(filtersFormControlOrGroup, item)"
      >
        {{ item?.value }}
        <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
      </mat-chip-row>
      }
      <input [matChipInputFor]="chipList" [readOnly]="true" class="pointer" />
      @if (filtersFormControlOrGroup?.value?.length < 2) {
      <ui-svg-icon [name]="iconNameList.ListView" class="svg_transform" matSuffix></ui-svg-icon>
      }
    </mat-chip-grid>
  </mat-form-field>
  } @case (filterType.MultipleSelect) {
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <mat-select [formControl]="filtersFormControlOrGroup" multiple>
      @for (option of filterSelectOptionsByName.get(name); track $index) {
      <mat-option [value]="option">
        @if (translatedFilterTitles.has($any(option))) {
        {{ translatedFilterTitles.get($any(option)) | translate }}
        } @else {
        {{ $any(option) | monitoringFilterAdjustUiPipe : name }}
        @if (name === allocationViewFilterName.UliOrigin) { ({{ $any(option)[0] }}) } }
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  } @case (filterType.DropDownSearchSelect) {
  <ui-select-search
    [selectControl]="filtersFormControlOrGroup"
    [optionItems]="filterSelectOptionsByName.get(name)"
    [placeholderName]="label"
    [noEntriesFoundLabel]="'common.message.noData' | translate"
  ></ui-select-search>
  } @case (filterType.MultipleDropDownSearchSelect) {
  <ui-select-search
    [selectControl]="filtersFormControlOrGroup"
    [optionItems]="filterSelectOptionsByName.get(name)"
    [placeholderName]="label"
    [noEntriesFoundLabel]="'common.message.noData' | translate"
    [isMultiple]="true"
  ></ui-select-search>
  } @case (filterType.DropDownSelect) {
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <mat-select [formControl]="filtersFormControlOrGroup">
      @for (option of filterSelectOptionsByName.get(name); track $index) {
      <mat-option [value]="option">
        {{ $any(option).name ?? option | titlecase }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  } @case (filterType.Input) {
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <input matInput [formControl]="filtersFormControlOrGroup" />
    <ui-svg-icon [name]="iconNameList.Search" class="svg_transform" matSuffix></ui-svg-icon>
    <mat-error>
      <ui-field-error-messages [control]="filtersFormControlOrGroup"></ui-field-error-messages>
    </mat-error>
  </mat-form-field>
  } @case (filterType.UppercaseInput) {
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <input matInput controlValueToUpperCase [formControl]="filtersFormControlOrGroup" />
    <ui-svg-icon [name]="iconNameList.Search" class="svg_transform" matSuffix></ui-svg-icon>
    <mat-error>
      <ui-field-error-messages [control]="filtersFormControlOrGroup"></ui-field-error-messages>
    </mat-error>
  </mat-form-field>
  } @case (filterType.RangeDatepicker) {
  <ui-date-time-range
    [formControl]="filtersFormControlOrGroup"
    [label]="label"
    [pickerType]="'calendar'"
    [timezone]="timezone"
  ></ui-date-time-range>
  } @case (filterType.CombinedRangeDatepicker) {
  <ui-combined-date-time-range
    [formControl]="filtersFormControlOrGroup"
    [label]="label"
    [pickerType]="'calendar'"
  ></ui-combined-date-time-range>
  } @case (filterType.Datepicker) {
  <ui-datepicker [formControl]="filtersFormControlOrGroup" [label]="label"></ui-datepicker>
  } @case (filterType.TimePicker) {
  <ui-datepicker [formControl]="filtersFormControlOrGroup" [label]="label" [pickerType]="'timer'"></ui-datepicker>
  } @case (filterType.RangeDatetimepicker) {
  <ui-date-time-range
    [formControl]="filtersFormControlOrGroup"
    [label]="label"
    [timezone]="timezone"
  ></ui-date-time-range>
  } @case (filterType.CheckboxListPopup) {
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <mat-chip-grid #chipList (click)="openFilterCheckboxDialog(label, filtersFormControlOrGroup)">
      @if (filtersFormControlOrGroup.value && name.match(userListFilterName.PartnerOwners)) { @for (partner of
      filtersFormControlOrGroup.value; track partner.id) {
      <span>
        <mat-chip-row [removable]="true" (removed)="removePartner(filtersFormControlOrGroup, partner.id)">
          {{ partner.name }}
          <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
        </mat-chip-row>
      </span>
      } } @else { @for (compartment of filtersFormControlOrGroup.value?.compartments; track compartment.id) {
      <span>
        <mat-chip-row [removable]="true" (removed)="removeCompartment(filtersFormControlOrGroup, compartment)">
          {{ compartment?.name }}
          <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
        </mat-chip-row>
        @for (dock of compartment?.docks; track dock.id) {
        <mat-chip-row
          [removable]="true"
          [matTooltip]="compartment?.name"
          (removed)="removeDock(filtersFormControlOrGroup, compartment, dock)"
        >
          {{ dock?.name }}
          <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
        </mat-chip-row>
        }
      </span>
      } }
      <input [matChipInputFor]="chipList" [readOnly]="true" class="pointer" />
      @if (filtersFormControlOrGroup?.value?.length < 2) {
      <ui-svg-icon [name]="iconNameList.ListView" class="svg_transform" matSuffix></ui-svg-icon>
      }
    </mat-chip-grid>
  </mat-form-field>
  } @case (filterType.Checkbox) {
  <mat-checkbox [formControl]="filtersFormControlOrGroup">
    {{ label }}
  </mat-checkbox>
  } @case (filterType.BorderedCheckbox) {
  <ui-bordered-control-wrapper>
    <mat-checkbox [formControl]="filtersFormControlOrGroup">
      {{ label }}
    </mat-checkbox>
  </ui-bordered-control-wrapper>
  } @case (filterType.ChipsInputSearch) {
  <ui-chips-with-search
    [label]="label"
    [itemOptions]="filterOptionsFacade[name] | async"
    [selectedItemsControl]="filtersFormControlOrGroup"
    [selectedItems]="selectedChipsInputSearchItems"
    (fetchItemsOptions)="filterOptionsFacade[name + 'LoadAll']($event)"
  ></ui-chips-with-search>
  } @case (filterType.ChipsInputSearchGeneric) {
  <ui-chips-with-search-generic
    [label]="label"
    [itemOptions]="filterOptionsFacade[name] | async"
    [selectedItemsControl]="filtersFormControlOrGroup"
    [selectedItems]="selectedChipsInputSearchItems"
    [optionNameKeys]="optionNameKeyForChipsInputSearchGeneric"
    [panelWidth]="searchCheckboxAutocompleteWidth"
    (fetchItemsOptions)="filterOptionsFacade[name + 'LoadAll']($event)"
  ></ui-chips-with-search-generic>
  } @case (filterType.ChipsInputSearchGenericWithCheckboxes) {
  <ui-chips-with-search-generic-and-checkboxes
    [label]="label"
    [itemOptions]="filterOptionsFacade[name] | async"
    [selectedItemsControl]="filtersFormControlOrGroup"
    [selectedItems]="selectedChipsInputSearchItems"
    [optionNameKeys]="optionNameKeyForChipsInputSearchGeneric"
    [panelWidth]="searchCheckboxAutocompleteWidth"
    (fetchItemsOptions)="filterOptionsFacade[name + 'LoadAll']($event)"
  ></ui-chips-with-search-generic-and-checkboxes>
  } @case (filterType.RadioButtonListPopup) {
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <mat-chip-grid #chipList (click)="openRadioDialog()">
      @if (filtersFormControlOrGroup.value && label === userItemEnum.Roles) {
      <span>
        <mat-chip-row [removable]="true" (removed)="remove()">
          {{ filtersFormControlOrGroup.value | roleGroupPipe }}
          <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
        </mat-chip-row>
      </span>
      } @if (filtersFormControlOrGroup.value && label === userItemEnum.Locations) {
      <span>
        <mat-chip-row [removable]="true" (removed)="remove()">
          {{ selectedLocation }}
          <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
        </mat-chip-row>
      </span>
      }
      <input [matChipInputFor]="chipList" [readOnly]="true" class="pointer" />
    </mat-chip-grid>
  </mat-form-field>
  } }
</div>
